/**
 * QuizBuilderSteps
 * Enum representing steps in the quiz builder.
 *
 * @property BASIC_INFO - Basic information step.
 * @property QUESTIONS - Questions step.
 * @property SETTINGS - Settings step.
 */
export enum QuizBuilderSteps {
  BASIC_INFO = 'basic-info',
  QUESTIONS = 'questions',
  SETTINGS = 'settings',
}
